import { Component } from '@angular/core';
import { AuthService } from '../../Services/auth.service';

@Component({
  selector: 'app-site-setting',
  standalone: false,
  templateUrl: './site-setting.component.html',
  styleUrl: './site-setting.component.css'
})
export class SiteSettingComponent {
 
  menuItems = [
    { path: "UsersManuePage", label: "manageUsers", icon: "❤️" },
    { path: "PagesManuePage", label: "Manage Web Pages", icon: "✏️" },
    { path: "BlogsManuePage", label: "Manage Blog", icon: "✏️" }
  ];
  getIcon(path: string): string {
    const iconMap: { [key: string]: string } = {
      "UsersManuePage": "fa-solid fa-user-lock text-primary",  
      "PagesManuePage": "fa-solid fa-globe text-primary", 
      "BlogsManuePage": "fa-solid fa-newspaper text-primary", 
      
    };
    return iconMap[path] || "bi bi-circle"; 
  }
userRole:string
constructor(private auth:AuthService){
    this.userRole=this.auth.getRoles();
}
}
